import {getCompetitionLinkPath} from 'app/helpers/actionsHelpers';
import {convertToRoman} from 'app/helpers/convertToRoman';

const selectFollowInfo = {
  competition: entity => {
    return {
      imageType: 'competition',
      path: getCompetitionLinkPath(entity),
      name: entity.name,
    };
  },
  profile: entity => {
    return {
      imageType: 'player',
      name: `${entity.firstName} ${entity.lastName}`,
      path: 'player',
    };
  },
  team: entity => {
    const teamName = entity.level > 1 ? entity.names.middle + ' ' + convertToRoman(entity.level) : entity.names.middle;
    return {
      imageType: 'emblem',
      name: teamName,
      path: 'team',
    };
  },
};

const FOLLOWABLE_SEARCH_ENTITIES = ['player', 'teamseason', 'competition'];
const MY_MATCHES_SEARCH_ENTITIES = ['teamseason', 'competition'];

export {selectFollowInfo, FOLLOWABLE_SEARCH_ENTITIES, MY_MATCHES_SEARCH_ENTITIES};
